const ContactUsPage = {
  seo: {
    title: 'Contact Us',
  },
};

export default ContactUsPage;

export const ContactUsSubmittedPage = {
  seo: {
    title: 'Message Sent',
  },
  title: 'Thank you for reaching out!',
  subtitle: "We'll get back to you as soon as possible.",
  successIcon: {
    alt: 'Success',
  },
  actions: {
    submitAnother: {
      label: 'Submit another message',
      dataTestId: 'contact-us-submit-another-button',
    },
    backToHome: {
      label: 'Back to Home',
      dataTestId: 'contact-us-back-to-home-link',
    },
  },
};
